import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
    interaction: {
        backgroundColor: tokens.colorNeutralBackground1,
        minHeight: "30vh",
        maxHeight: "calc(100vh - 150px)",
        ...shorthands.margin("16px", "16px", "16px"),
        boxShadow: tokens.shadow4,
        flexShrink: 0,
        overflowY: "auto"
    },
    audioPlayer: {
        marginTop: "30px",
        minHeight: "60px",
    },
    transcription: {
        ...shorthands.margin("16px", "100px", "64px"),
    },
    middle: {
        height: "60px",
        maxHeight: "60px",
    },
});
